module.exports = "/_next/static/images/bg-info-extend-5-d85509f0.png";